module.exports = __webpack_public_path__ + "static/media/ServiceLandingPage.41a344b7.jpeg";